<template>
  <div class="game-iframe-page">
    <header class="game-iframe-header">
      <button
        type="button"
        class="game-iframe-header__action game-iframe-header__action--deposit"
        :aria-label="depositLabel"
        @click="goDeposit"
      >
        <i class="fas fa-wallet" aria-hidden="true"></i>
      </button>

      <div class="game-iframe-header__info">
        <h1 class="game-iframe-header__title">{{ displayGameName }}</h1>
        <p v-if="displayProvider" class="game-iframe-header__provider">{{ displayProvider }}</p>
      </div>

      <button
        type="button"
        class="game-iframe-header__action game-iframe-header__action--home"
        :aria-label="homeLabel"
        @click="goHome"
      >
        <i class="fas fa-home" aria-hidden="true"></i>
      </button>
    </header>

    <iframe
      name="game-iframe"
      class="game-iframe-frame"
      :srcdoc="isHttp ? null : iframeURL"
      :src="isHttp ? iframeURL : null"
      allow="autoplay; fullscreen; payment"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  computed: {
    iframeURL() {
      return this.$store.state.iframeURL;
    },
    displayGameName() {
      return this.$store.state.iframeGameName
        || (this.$store.state.language === 'en' ? 'Game' : 'ဂိမ်း');
    },
    displayProvider() {
      return this.$store.state.iframeGameProvider;
    },
    isHttp() {
      const url = this.iframeURL || '';
      return url.startsWith('http://') || url.startsWith('https://');
    },
    depositLabel() {
      return this.$t('setting.deposit');
    },
    homeLabel() {
      return this.$store.state.language === 'en' ? 'Home' : 'ပင်မစာမျက်နှာ';
    },
  },
  methods: {
    goDeposit() {
      this.$store.commit('clearIframeGame');
      this.$router.push('/deposit').catch(() => {});
    },
    goHome() {
      this.$store.commit('clearIframeGame');
      this.$router.push('/home').catch(() => {});
    },
  },
  mounted() {
    if (!this.iframeURL) {
      this.$router.push('/home').catch(() => {});
    }
  },
  beforeDestroy() {
    this.$store.commit('clearIframeGame');
  },
};
</script>

<style scoped>
.game-iframe-page {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: #050505;
  overflow: hidden;
}

.game-iframe-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0.65rem;
  min-height: 3.25rem;
  padding: 0.5rem 0.65rem;
  padding-top: calc(0.5rem + env(safe-area-inset-top, 0));
  background: linear-gradient(180deg, #141414 0%, #0a0a0a 100%);
  border-bottom: 1px solid rgba(207, 167, 87, 0.35);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.45);
  z-index: 2;
}

.game-iframe-header__action {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid rgba(207, 167, 87, 0.35);
  border-radius: 12px;
  background: rgba(207, 167, 87, 0.08);
  color: var(--text-gold);
  cursor: pointer;
  transition: background 0.15s ease, transform 0.15s ease;
}

.game-iframe-header__action:active {
  transform: scale(0.94);
}

.game-iframe-header__action--deposit {
  background: rgba(207, 167, 87, 0.15);
}

.game-iframe-header__action--home {
  background: rgba(207, 167, 87, 0.15);
}

.game-iframe-header__info {
  flex: 1;
  min-width: 0;
  text-align: center;
}

.game-iframe-header__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: var(--text-gold);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.02em;
}

.game-iframe-header__provider {
  margin: 0.15rem 0 0;
  font-size: 0.72rem;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.game-iframe-frame {
  flex: 1;
  width: 100%;
  min-height: 0;
  border: none;
  background: #04090a;
}
</style>
